import { getCaretTextPosition, serializeEditorLink, } from '@/helpers/richEditorHelper';
const shouldAddSpaceBefore = (value) => (value.length > 0 &&
    !/[\s([{]$/.test(value));
const shouldAddSpaceAfter = (value) => (value.length > 0 &&
    !/^[\s.,!?;:)\]}]/.test(value));
export const insertEmailTemplateLink = (field, currentValue, link, requestedPosition) => {
    const linkHtml = serializeEditorLink(link.text, link.url);
    const insertionPosition = Math.min(Math.max(requestedPosition ?? currentValue.length, 0), currentValue.length);
    const before = currentValue.slice(0, insertionPosition);
    const after = currentValue.slice(insertionPosition);
    const prefix = shouldAddSpaceBefore(before) ?
        ' ' :
        '';
    const suffix = shouldAddSpaceAfter(after) ?
        ' ' :
        '';
    return {
        field,
        value: before +
            prefix +
            linkHtml +
            suffix +
            after,
        caretPosition: before.length +
            prefix.length +
            linkHtml.length +
            suffix.length,
    };
};
export const updateEmailTemplateLink = (currentValue, editingLink, link) => {
    const newLinkHtml = serializeEditorLink(link.text, link.url);
    const { field, tokenStart, tokenLength, } = editingLink;
    return {
        field,
        value: currentValue.slice(0, tokenStart) +
            newLinkHtml +
            currentValue.slice(tokenStart + tokenLength),
        caretPosition: tokenStart + newLinkHtml.length,
    };
};
export const deleteEmailTemplateLink = (currentValue, editingLink) => {
    const { field, tokenStart, tokenLength, } = editingLink;
    return {
        field,
        value: currentValue.slice(0, tokenStart) +
            currentValue.slice(tokenStart + tokenLength),
        caretPosition: tokenStart,
    };
};
export const createEditingEmailTemplateLink = (editor, chip, field) => {
    const text = chip.dataset.linkText || '';
    const url = chip.dataset.linkUrl || '';
    if (!text || !url) {
        return null;
    }
    const rangeBeforeChip = document.createRange();
    rangeBeforeChip.setStartBefore(chip);
    rangeBeforeChip.collapse(true);
    const tokenStart = getCaretTextPosition(editor, rangeBeforeChip);
    const currentLinkHtml = serializeEditorLink(text, url);
    return {
        field,
        tokenStart,
        tokenLength: currentLinkHtml.length,
        text,
        url,
    };
};
